export default {
    install (Vue) {
        Vue.prototype.$notify = function ({ content, color, multiline }) {
            this.$store.commit('snackbar/showMessage', { content, color, multiline })
        }
    }
}
